import React from 'react';
import { useSelector } from 'react-redux';
import UsersHospitalsForm from '../../../components/UsersHospitalsForm/UsersHospitalsForm';
import "./style.scss";

function AddHospital() {
  const user = useSelector((state) => state.auth?.user?.data);

  if (user?.role_id !== 1) {
    return "Your are not authorized to view this page";
  }
    
  return (
    <div>
        <UsersHospitalsForm userslab={null} />
    </div>
  );
}

export default AddHospital
